module.exports = __webpack_public_path__ + "6d0809a1d4b130d478c29e2f43de7f0d.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/perks/wall_items/pirate-flag.png
// module id = 3437
// module chunks = 0